import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col bg-plum-950 overflow-hidden" data-id="element-152">
      {/* Ambient color wash */}
      <div className="absolute inset-0 bg-gradient-to-tr from-lavender-600/15 via-transparent to-rose-500/15 pointer-events-none" data-id="element-153"></div>

      {/* Logo zone — top, unobstructed */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      delay: 0.1
    }} className="relative z-10 w-full flex items-center justify-center pt-28 pb-6 md:pt-32 md:pb-8" data-id="element-154">
        <img src="https://cdn.magicpatterns.com/uploads/1V34po7eNFbeZSJ6yk24Pz/Mass_Logo_.png" alt="Afriel Massage" className="w-full max-w-2xl md:max-w-3xl h-auto object-contain drop-shadow-[0_10px_40px_rgba(180,130,200,0.35)] rounded-3xl" data-id="element-155" />
      </motion.div>

      {/* Subtle divider */}
      <div className="relative z-10 max-w-md mx-auto w-full px-6" data-id="element-156">
        <div className="h-[1px] bg-gradient-to-r from-transparent via-lavender-400/40 to-transparent" data-id="element-157"></div>
      </div>

      {/* Text & CTA zone — below the logo */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-6 py-12 md:py-16 max-w-4xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-lavender-400/10 border border-lavender-400/30 backdrop-blur-sm mb-6" data-id="element-159">
          <MapPin size={14} className="text-lavender-300" data-id="element-160" />
          <span className="text-lavender-200 uppercase tracking-[0.2em] text-xs" data-id="element-161">
            Los Angeles · Private Sanctuary
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl text-lavender-50 mb-6 leading-tight" data-id="element-162">
          The Art of{' '}
          <span className="italic bg-gradient-to-r from-lavender-300 via-rose-400 to-lavender-400 bg-clip-text text-transparent" data-id="element-163">
            Sensual Touch
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-base md:text-lg text-lavender-100/85 font-light max-w-2xl mx-auto mb-10" data-id="element-164">
          An intimate sanctuary in the heart of Los Angeles. Every session is
          private, discreet, and crafted for your absolute pleasure and
          relaxation.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-165">
          <a href="#reservations" className="inline-block px-10 py-4 bg-gradient-to-r from-lavender-500 to-rose-500 text-white uppercase tracking-widest text-sm hover:shadow-2xl hover:shadow-lavender-500/40 transition-all duration-300 rounded-full" data-id="element-166">
            Reserve Your Session
          </a>
          <a href="#services" className="inline-block px-10 py-4 border border-lavender-300/40 text-lavender-100 uppercase tracking-widest text-sm hover:bg-lavender-400/10 transition-all duration-300 rounded-full" data-id="element-167">
            Explore Services
          </a>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="relative z-10 flex flex-col items-center pb-6" data-id="element-168">
        <span className="text-xs uppercase tracking-widest text-lavender-200/50 mb-2" data-id="element-169">
          Scroll
        </span>
        <div className="w-[1px] h-10 bg-gradient-to-b from-lavender-400/60 to-transparent" data-id="element-170"></div>
      </motion.div>
    </section>;
}